module.exports = __webpack_public_path__ + "img/why-ico3.e0ef7af5.png";